import FormItem from './fromItem/fromItem'
import Table from './table/table'

const components = [
  FormItem,
  Table
]

const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}
